import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import * as ep from '../api/endpoints';
import { PeriodPicker } from '../components/PeriodPicker';
import { Empty, ErrorBox, Loading, Money } from '../components/ui';
import { formatDate, formatDateTime } from '../lib/dates';

/** İptaller / iadeler: silinmeyen kayıtlar, gerekçe, tutar, kaynak fiş, işlem tarihi ve etkilediği ay (PDF §04). */
export function CancelRefundScreen() {
  const [tab, setTab] = useState<'refunds' | 'cancellations'>('refunds');
  const [periodId, setPeriodId] = useState<string | undefined>();
  const refunds = useQuery({ queryKey: ['refunds', periodId], queryFn: () => ep.refunds(periodId), enabled: tab === 'refunds' });
  const cancels = useQuery({ queryKey: ['cancellations', periodId], queryFn: () => ep.cancellations(periodId), enabled: tab === 'cancellations' });
  return (
    <div>
      <h1>İptaller ve iadeler</h1>
      <div className="row" style={{ marginBottom: 8 }}>
        <div style={{ minWidth: 220 }}><PeriodPicker value={periodId} onChange={setPeriodId} /></div>
        {periodId && <button className="btn small" onClick={() => setPeriodId(undefined)}>Tüm dönemler</button>}
      </div>
      <div className="tabs" role="tablist">
        <button role="tab" aria-selected={tab === 'refunds'} className={tab === 'refunds' ? 'active' : ''} onClick={() => setTab('refunds')}>İadeler</button>
        <button role="tab" aria-selected={tab === 'cancellations'} className={tab === 'cancellations' ? 'active' : ''} onClick={() => setTab('cancellations')}>İptaller</button>
      </div>
      {tab === 'refunds' ? (
        <>
          <ErrorBox error={refunds.error} />
          {!refunds.data ? <Loading /> : !refunds.data.length ? <Empty>İade kaydı yok.</Empty> : (
            <div className="card scroll-x">
              <table className="t">
                <thead><tr><th>Kaynak fiş</th><th>Sahip</th><th>İade tarihi</th><th>Etkilediği ay</th><th>Gerekçe</th><th className="num">Tutar</th></tr></thead>
                <tbody>
                  {refunds.data.map((r) => (
                    <tr key={r.id}>
                      <td><Link to={`/fis/${r.source_receipt_id}`}>{r.source_receipt_id.slice(0, 8)}</Link></td>
                      <td>{r.owner_name}</td>
                      <td>{formatDate(r.refund_date)}</td>
                      <td>{r.year_month}</td>
                      <td>{r.reason}{r.partial && <span className="badge warn" style={{ marginLeft: 6 }}>Kısmi</span>}</td>
                      <td className="num"><Money value={`-${r.amount}`} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      ) : (
        <>
          <ErrorBox error={cancels.error} />
          {!cancels.data ? <Loading /> : !cancels.data.length ? <Empty>İptal kaydı yok.</Empty> : (
            <div className="card scroll-x">
              <table className="t">
                <thead><tr><th>Fiş</th><th>Sahip</th><th>İşlem tarihi</th><th>Gerekçe</th><th className="num">Düşülen</th></tr></thead>
                <tbody>
                  {cancels.data.map((c) => (
                    <tr key={c.id}>
                      <td><Link to={`/fis/${c.receipt_id}`}>{c.receipt_id.slice(0, 8)}</Link></td>
                      <td>{c.owner_name}</td>
                      <td>{formatDateTime(c.created_at)}</td>
                      <td>{c.reason}</td>
                      <td className="num"><Money value={`-${c.amount}`} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
